import { userStore } from '@/store';

/**
 * 金融機関支店ユーザー判定
 */
export const isBranchUser = (): boolean => {
  return userStore.loginUser.user_type === 'branch_user';
};
